import axios from 'axios'
import { dcostUrl } from '../config'

export default {
  // 埋点
  log (params, headers) {
    return axios.post(`${dcostUrl}/common/log`, params, { headers })
      .then(res => res.data)
  }
}
